/* Marks the sidebar link for the section currently being read.
 *
 * WHY NOT :target -- it only updates when a link is clicked, so it goes stale
 * the moment somebody scrolls past the section they jumped to, which is the
 * normal way this page gets used. An observer follows the reader instead.
 *
 * WHY THE TOP BAND, NOT visibility -- several sections are visible at once on
 * a tall screen, so "is it on screen" cannot pick one. The rule here is the
 * last heading to have crossed the top quarter of the viewport, which is the
 * one whose text you are actually reading.
 *
 * PROGRESSIVE, NOT REQUIRED. If this never runs the links still jump to their
 * anchors, which is the whole benefit of the sidebar; only the highlight is
 * missing.
 */
(function () {
  var list = document.querySelector('[data-help-nav]');
  if (!list || !('IntersectionObserver' in window)) return;

  var links = [].slice.call(list.querySelectorAll('a[href^="#"]'));
  if (!links.length) return;

  /* The scheme for the active fill is carried on the list rather than written
     into the stylesheet, so the highlight recolours with the section. */
  var scheme = list.getAttribute('data-active-scheme');
  if (scheme) {
    links.forEach(function (link) { link.setAttribute('data-color-scheme', scheme); });
  }

  var sections = links
    .map(function (link) {
      var id = decodeURIComponent(link.getAttribute('href').slice(1));
      var el = document.getElementById(id);
      return el ? { link: link, el: el } : null;
    })
    .filter(Boolean);
  if (!sections.length) return;

  var current = null;

  function setActive(entry) {
    if (entry === current) return;
    if (current) current.link.classList.remove('is-active');
    entry.link.classList.add('is-active');
    current = entry;
  }

  function update() {
    /* A quarter down the viewport: far enough that a heading scrolling in at
       the very bottom does not steal the highlight from the one being read. */
    var line = window.innerHeight * 0.25;
    var chosen = sections[0];
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].el.getBoundingClientRect().top <= line) chosen = sections[i];
    }
    setActive(chosen);
  }

  /* The observer is only a cheap trigger -- it fires when any section crosses
     the viewport, and update() then decides which one wins. Reading positions
     in the callback rather than trusting entry order avoids the classic bug
     where fast scrolling delivers entries out of order. */
  var pending = false;
  var observer = new IntersectionObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      update();
    });
  });

  sections.forEach(function (s) { observer.observe(s.el); });

  window.addEventListener('scroll', function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      update();
    });
  }, { passive: true });

  update();
})();
